import {Option} from '@emm/core/models/option.model';

function getBooleanList(required: boolean = false): Option[] {
    return [
        ...(required ? [] : [{ value: '', label: '(empty)' }]),
        { value: 'true', label: 'True' },
        { value: 'false', label: 'False' }
    ];
}

function convertBooleans(model: {}) {
    return (
        model &&
        Object.keys(model).reduce((object, key) => {
            // TODO: need to revisit this
            let value;
            if (model[key] === 'false') {
                value = false;
            } else if (model[key] === 'true') {
                value = true;
            } else {
                value = model[key];
            }
            return { ...object, [key]: value };
        }, {})
    );
}

export const FormlyUtil = {
    convertBooleans,
    getBooleanList
};
